import React, { useEffect } from 'react'
import PageCard from '../../common/PageCard'
import Page from '../../common/Page'
import $t from '../../../i18n'
import ProviderItem from '../FindAProvider/ProviderItem'
import { useDispatch, useSelector } from 'react-redux'
import { Button } from 'antd'
import Actions from '../../../actions'
import { routes } from '../../../consts'
import { setUrlParams } from '../../../utils/useParamUtil'
import Alert from '../../common/Alert'
import sortBy from 'lodash/sortBy'
import { ProviderPCPTypes } from 'consts/ProviderConsts'
import './CareTeam.css'

const CareTeam = () => {
  const dispatch = useDispatch()
  const { telehealthPcp, physicalPcp, isCareTeamLoading, pcpUpdateError } =
    useSelector(state => state.providers)
  const selectedMember = useSelector(state => state.account?.selectedMember)
  const userDetails = useSelector(state => state.profile?.userDetails)

  const isNotAdmin = selectedMember?.id !== userDetails?.id

  useEffect(() => {
    // if there is no selected member or the selected member is not insured, we need to select the current user admin
    if (!selectedMember?.id || !selectedMember?.hmo_member_id) {
      dispatch(
        Actions.createAction(Actions.CHOOSE_FAMILY_MEMBER, {
          member: userDetails
        })
      )
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  // in case selected Member changed and its not equal to current user,
  // we need to update the care team
  useEffect(() => {
    if (selectedMember?.id && isNotAdmin) {
      dispatch(
        Actions.createAction(Actions.PROVIDER_PCP_REQUESTED, {
          patientId: selectedMember?.id
        })
      )
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedMember])

  const telehealthPCPToDisplay = isNotAdmin
    ? telehealthPcp
    : userDetails?.telehealthPcp
  const physicalPCPToDisplay = isNotAdmin
    ? physicalPcp
    : userDetails?.physicalPcp

  // navigate to the provider page
  const navigateToProviderPage = providerId => {
    dispatch(
      Actions.createAction(
        Actions.NAVIGATED_TO,
        routes.PROVIDER_DETAILS.replace(':id', providerId)
      )
    )
  }

  const onChangePCP = () => {
    dispatch(
      Actions.createAction(
        Actions.NAVIGATED_TO,
        `${routes.SEARCH_PROVIDERS_RESULTS}?${setUrlParams({
          query: 'PCP',
          state: userDetails?.address?.find(ad => !!ad.state)?.state,
          changePcpType: ProviderPCPTypes.PHYSICAL,
          changePcp: true
        })}`
      )
    )
  }

  return (
    <PageCard className='care-team-page-card' enableBack={true}>
      <Page
        loading={isCareTeamLoading}
        className='care-team-page'
        title={$t('profile.careTeam.title')}
        hideAlertBanner={true}
        displayManageFamily
        manageFamilyProps={{
          isFamilyHidden: true,
          isNotEnsuredDisabled: true
        }}
      >
        <div className='care-team-wrapper'>
          {telehealthPCPToDisplay && (
            <ProviderItem
              provider={{
                ...telehealthPCPToDisplay,
                specialities: [
                  { name: $t('profile.careTeam.telehealthPhysician') }
                ]
              }}
              patientId={selectedMember?.id}
              isFamily={true}
              hideNewMembersIndication={true}
              providerTypeHeader={$t('profile.careTeam.yourPrimaryCare')}
              onClick={() => navigateToProviderPage(telehealthPCPToDisplay?.id)}
              shouldShowCTA={true}
            />
          )}
          <ProviderItem
            provider={{
              name: $t('profile.careTeam.firstAvailableClinician'),
              telehealth: true
            }}
            patientId={selectedMember?.id}
            isFamily={true}
            isFirstAvailableProvider={true}
            hideNewMembersIndication={true}
            shouldShowCTA={true}
          />
          {physicalPCPToDisplay &&
            sortBy(physicalPCPToDisplay, p => p?.end_date)?.map(pcp => (
              <ProviderItem
                key={pcp?.id}
                provider={{
                  ...pcp,
                  specialities: [
                    {
                      name: $t('profile.careTeam.primaryCare'),
                      specialty: pcp?.specialty
                    }
                  ]
                }}
                patientId={selectedMember?.id}
                isFamily={true}
                hideNewMembersIndication={true}
                providerTypeHeader={$t('profile.careTeam.physician')}
                onClick={() => navigateToProviderPage(pcp?.id)}
                shouldShowCTA={true}
              />
            ))}
          {/* <ProviderItem
          provider={{
            name: 'Dr. John Doe',
            email: 'email@gmail.com',
            prac_category_code: 'NP',
            care_coordinator: true,
            gender: 'male',
            provider_type: 'individual',
          }}
          hideNewMembersIndication={true}
          providerTypeHeader={$t('profile.careTeam.careCoordinator')}
          actionName={$t('profile.careTeam.sendEmail')}
          onActionClick={() => (window.location = 'mailto:email@gmail.com')}
        /> */}
          {!physicalPCPToDisplay ||
            (!physicalPCPToDisplay?.length && (
              <Button className='add-pcp-btn' onClick={onChangePCP}>
                {$t('profile.careTeam.selectPCP')}
              </Button>
            ))}
        </div>
        <Alert
          title={'Oh no!'}
          shouldDisplay={!!pcpUpdateError}
          onCancel={() => dispatch(Actions.createAction(Actions.CLEAR_ALERT))}
          onOk={() => dispatch(Actions.createAction(Actions.CLEAR_ALERT))}
        >
          {pcpUpdateError}
        </Alert>
      </Page>
    </PageCard>
  )
}

export default CareTeam
